/**
 * Открыта ли экранная клавиатура (docs/08-mobile-roadmap.md, M1).
 *
 * Прямого API нет: клавиатура уменьшает видимую область (visualViewport),
 * а окно (innerHeight) остаётся прежним — так в iOS Safari и в Chrome
 * для Android по умолчанию. Разница больше порога — значит клавиатура.
 * Масштаб щипком тоже уменьшает видимую область, поэтому высота
 * приводится к масштабу 1.
 */

import { useSyncExternalStore } from "react";

/** Панель подсказок над клавиатурой бывает ~50 px, сама клавиатура — от 250. */
const THRESHOLD_PX = 150;

function subscribe(onChange: () => void): () => void {
  const viewport = window.visualViewport;
  if (viewport === null) return () => undefined;
  viewport.addEventListener("resize", onChange);
  return () => viewport.removeEventListener("resize", onChange);
}

function snapshot(): boolean {
  const viewport = window.visualViewport;
  if (viewport === null) return false;
  return window.innerHeight - viewport.height * viewport.scale > THRESHOLD_PX;
}

export function useVirtualKeyboardOpen(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
